import { CalendarCheck } from 'lucide-react';
import { useNavigate } from 'react-router';
import { routes } from '@config/routes';
import { useMe } from '@features/user-profile/hooks/useMe';
import { todayKeyInTz } from '@shared/lib/userTz';
import { BRAND_GRADIENT } from '@shared/styles/brand';

/**
 * Spec §1/§2: the Topbar action that opens the Calendar on the trader's OWN today, already on the
 * `Plan My Day` tab (`/calendar?date=YYYY-MM-DD&tab=plan`).
 *
 * The date is resolved in the profile time zone (`todayKeyInTz`), never from the browser clock's UTC
 * date — at 21:00 in Chicago the day to plan is still today's, even though UTC has rolled over. It is
 * recomputed on click rather than at render so a tab left open past local midnight still lands on the
 * right day.
 *
 * Mounted only when `featurePlanMyDay` is on (see `Topbar.tsx`).
 */
export function PlanMyDayButton() {
  const navigate = useNavigate();
  const me = useMe();
  return (
    <button
      type="button"
      onClick={() => navigate(`${routes.calendar}?date=${todayKeyInTz(me.data?.timeZone)}&tab=plan`)}
      className="inline-flex h-9 items-center gap-1.5 rounded-lg px-3.5 text-[13px] font-semibold text-white transition-opacity hover:opacity-90"
      style={{ background: BRAND_GRADIENT }}
    >
      <CalendarCheck className="h-4 w-4" aria-hidden />
      Plan My Day
    </button>
  );
}
